<template>
  <div>
    <p>Cardápio</p>
  </div>
</template>

<script>
export default {
  created () {
    window.location.href = 'http://www.ilhadocaranguejo.com/'
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Cardapio.vue